import axios from 'axios';
// import { useAuth } from '../context/AuthContext';

const BACKEND_URL = window.process.env.BACKEND_API_URL;
const api = axios.create({
  baseURL: BACKEND_URL,
});

api.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
  response => response,
  async (error) => {
    // const { logout } = useAuth();
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;  // Prevent infinite loops

        try {
            // Request a new access token
            const { data } = await axios.post(
                `${BACKEND_URL}/api/auth/refresh-token`,
                {},  // No body needed
                { withCredentials: true }  // Ensure cookies are sent
            );

            // Store new token and retry original request
            localStorage.setItem("token", data.accessToken);
            api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
            originalRequest.headers["Authorization"] = `Bearer ${data.accessToken}`;

            return api(originalRequest);
        } catch (err) {
            console.error("Session expired. Please log in again.");
            localStorage.removeItem("token");  // Clear invalid token
            // logout();
        }
    }

    return Promise.reject(error);
  }
);

export const fetchConfigs = async () => {
  try {
    const response = await api.get('/api/configs');
    return response.data;      
  } catch (error) {
    throw error;
  }
}

export const putConfigs = async (data) => {

  const response = await api.put(`/api/configs`, data);
  return response.data;
}

export const createConfigs = async (data) => {

  const response = await api.post(`/api/configs`, data);
  return response.data;
}

export const initConfigs = async () => {
  const response = await api.post('/api/configs/init', null);
  return response.data;
}

export default api;